const o = (e) => typeof e == "string" && (e === "primary" || e === "secondary" || e === "tertiary" || e === "ghost" || e === "text"), t = (e) => o(e) ? e : "secondary";
export {
  t as fallbackVariant,
  o as validateVariant
};
